import React from "react";

interface CardSectionProps {
  headingText: string;
  data: string | JSX.Element | null;
}

const CardSection: React.SFC<CardSectionProps> = ({
  headingText,
  data,
}: CardSectionProps): JSX.Element => {
  return (
    <div
      style={{
        marginBottom: "10px",
      }}
    >
      <div className="heading-container">
        <span
          className="block-element"
          style={{
            fontWeight: "bold",
            fontSize: "12px",
          }}
        >
          {headingText}
        </span>
        <span
          style={{
            fontSize: "13px",
            color: "#333",
          }}
        >
          {data}
        </span>
      </div>
    </div>
  );
};

export default CardSection;
